export default "__VITE_ASSET__C0rO5jLU__"